import Constant from '@/const';
import axios from 'axios';

const deleteUnit = async id => {
  try {
    const response = await axios.delete(
      Constant.apiUrl.concat(`/master/unit/${id}`),
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default deleteUnit;
